import { a as h, n as v, e as f, u as l } from "../dummyModel-DGc8qBEQ.js";
import { i as P } from "../utils-Mz58x57M.js";
import { useCallback as w } from "react";
const O = (e, r) => e.titlePartOverrides.FILTER ? e.titlePartOverrides.FILTER : e.additionalFilters.length === 0 ? "" : e.additionalFilters.map((i) => `${i.reference.alias}: ${P(i, r)}`).join(", "), $ = (e, r) => e.titlePartOverrides.PERIOD ? e.titlePartOverrides.PERIOD : e.overridePeriod === void 0 ? "" : r.getTranslatedName(e.overridePeriod), x = (e, r, i, n) => w((u) => r.map((a) => {
  var p, g;
  const t = u.find((c) => c.metricCode === a.metricCode), o = t ? h(e, t) : void 0, d = t && n ? v(n, {
    metricCode: t.metricCode,
    metricAlias: t.metricAlias,
    viewCode: t.viewCode
  }, !0) : a.reference.id, s = (o == null ? void 0 : o.asRatio) && (o.formatSuffix === "%" || o.formatPrefix === "%") || ((g = (p = u.find((c) => (i ? d : a.reference.alias) === c.metricAlias)) == null ? void 0 : p.growth) == null ? void 0 : g.type) === f.RATIO;
  return {
    ...a,
    reference: {
      id: d ?? a.reference.id,
      alias: i ? d ?? a.reference.alias : a.reference.alias,
      code: (t == null ? void 0 : t.metricCode) ?? a.reference.code,
      ...t && o ? {
        description: o.description ?? "",
        prefix: s ? "" : o.formatPrefix,
        suffix: s ? "%" : o.formatSuffix,
        asPercentage: s
      } : {}
    }
  };
}), [r, i, e, n]), C = (e, r) => {
  var i, n, u, a, t, o, d, s;
  if (e.titlePartOverrides.GROWTH)
    return e.titlePartOverrides.GROWTH;
  if (e.growth === void 0)
    return "";
  switch ((i = e.growth) == null ? void 0 : i.type) {
    case f.DIFFERENCE:
      return `(vs ${r.get(`growth.value.${l((n = e.growth) == null ? void 0 : n.period)}`, (u = e.growth) == null ? void 0 : u.period.quantity)})`;
    case f.VALUE:
      return `(${r.get(`growth.value.${l((a = e.growth) == null ? void 0 : a.period)}`, (t = e.growth) == null ? void 0 : t.period.quantity)})`;
    case f.RATIO:
      return `(% vs ${r.get(`growth.value.${l((o = e.growth) == null ? void 0 : o.period)}`, (d = e.growth) == null ? void 0 : d.period.quantity)})`;
    case void 0:
      return "";
    case null:
      return "";
    default:
      (s = e.growth) == null || s.type;
      return;
  }
};
function y(e, r) {
  var n;
  const { metricDef: i } = e;
  return i ? `${(n = e.metricDef) == null ? void 0 : n.alias} ${O(e, r)} ${$(e, r)} ${C(e, r)}` : "";
}
export {
  y as buildMetricLabel,
  C as getGrowthLabel,
  O as getMetricFilterLabel,
  $ as getMetricPeriodLabel,
  x as useMetricFilterConverterToConfModel
};
//# sourceMappingURL=utils.js.map
